/**
 * @generated SignedSource<<57b5f3d6a4d14fdaf97abcc9c369a34c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MetaAdCallToAction = "CONTACT_US" | "GET_QUOTE" | "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "SUBSCRIBE" | "%future added value";
export type MetaAdSetEffectiveStatus = "ACTIVE" | "ARCHIVED" | "CAMPAIGN_PAUSED" | "DELETED" | "IN_PROCESS" | "PAUSED" | "WITH_ISSUES" | "%future added value";
export type MetaAdSetStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CreativeTextForm$data = {
  readonly callToAction: MetaAdCallToAction | null;
  readonly description: string | null;
  readonly destinationUrl: string | null;
  readonly displayUrl: string | null;
  readonly facebookPage: {
    readonly id: string;
    readonly name: string;
    readonly picture: string;
  } | null;
  readonly headline: string | null;
  readonly id: string;
  readonly instagramAccount: {
    readonly id: string;
    readonly name: string;
    readonly picture: string;
  } | null;
  readonly metaAdMetaAdSets: ReadonlyArray<{
    readonly metaAdSet: {
      readonly campaignName: string | null;
      readonly effectiveStatus: MetaAdSetEffectiveStatus | null;
      readonly id: string;
      readonly metaAdAccount: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly name: string | null;
      readonly status: MetaAdSetStatus | null;
    };
  }>;
  readonly name: string | null;
  readonly primaryText: string | null;
  readonly " $fragmentType": "CreativeTextForm";
};
export type CreativeTextForm$key = {
  readonly " $data"?: CreativeTextForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeTextForm">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "picture",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeTextForm",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "callToAction",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "destinationUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacebookPage",
      "kind": "LinkedField",
      "name": "facebookPage",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InstagramAccount",
      "kind": "LinkedField",
      "name": "instagramAccount",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaAdMetaAdSet",
      "kind": "LinkedField",
      "name": "metaAdMetaAdSets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MetaAdSet",
          "kind": "LinkedField",
          "name": "metaAdSet",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "campaignName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MetaAdAccount",
              "kind": "LinkedField",
              "name": "metaAdAccount",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "effectiveStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MetaAd",
  "abstractKey": null
};
})();

(node as any).hash = "7762b034a082d4458954b759db3c3047";

export default node;
